/*
  Hariswad Premium Enhancements — behaviour layer.

  Currently adds one feature: a sticky mobile "Add to cart" bar on product
  pages. It never invents data — the title, price, button label and
  disabled/sold-out state are all read live from the real product form on
  the page, and its button relays a click to the theme's genuine Add to
  cart button so the existing validation, loading state and cart drawer
  continue to work exactly as they already do.

  No-ops safely if the expected markup isn't found (e.g. non-product pages).
*/
(function () {
  'use strict';

  function initStickyAddToCart() {
    var mainProductSection = document.querySelector('[id^="MainProduct-"]');
    if (!mainProductSection) return;

    var submitButton = mainProductSection.querySelector('.product-form__submit');
    if (!submitButton) return;

    // Avoid double-initializing if this ever runs twice.
    if (document.querySelector('.sticky-atc-bar')) return;

    var titleEl =
      mainProductSection.querySelector('.product__title h1') ||
      mainProductSection.querySelector('.product__title');
    var priceWrapper = mainProductSection.querySelector('[id^="price-"]');
    var priceEl = priceWrapper
      ? priceWrapper.querySelector('.price-item--regular, .price-item')
      : null;

    var bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';

    var info = document.createElement('div');
    info.className = 'sticky-atc-bar__info';

    var titleSpan = document.createElement('span');
    titleSpan.className = 'sticky-atc-bar__title';
    titleSpan.textContent = titleEl ? titleEl.textContent.trim() : document.title;

    var priceSpan = document.createElement('span');
    priceSpan.className = 'sticky-atc-bar__price';
    priceSpan.textContent = priceEl ? priceEl.textContent.trim() : '';

    info.appendChild(titleSpan);
    info.appendChild(priceSpan);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--primary sticky-atc-bar__button';

    function syncButtonState() {
      var span = submitButton.querySelector('span');
      button.textContent = span && span.textContent.trim() ? span.textContent.trim() : submitButton.textContent.trim();
      button.disabled = submitButton.disabled;
    }
    syncButtonState();

    button.addEventListener('click', function () {
      submitButton.click();
    });

    bar.appendChild(info);
    bar.appendChild(button);
    document.body.appendChild(bar);

    // Keep the sticky button's label/disabled state in sync with the real
    // one (e.g. when a customer picks a sold-out variant).
    var stateObserver = new MutationObserver(syncButtonState);
    stateObserver.observe(submitButton, { attributes: true, childList: true, subtree: true });

    if (priceWrapper) {
      var priceObserver = new MutationObserver(function () {
        var updated = priceWrapper.querySelector('.price-item--regular, .price-item');
        priceSpan.textContent = updated ? updated.textContent.trim() : '';
      });
      priceObserver.observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
            } else if (entry.boundingClientRect.top < 0) {
              bar.classList.add('is-visible');
            } else {
              bar.classList.remove('is-visible');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(submitButton);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }
})();
